import { getFundInfo } from '../../api/fund.api';
import { FundInfoData } from '../../types/fundsummary.type';
import useFundResource, { FundResourceResult } from './useFundResource';

const useFundInfo = (
  ric: string = '',
  token: string = '',
  saleInCountryCode: string = 'US',
): FundResourceResult<FundInfoData> =>
  useFundResource<FundInfoData>(getFundInfo, ric, token, saleInCountryCode);

export default useFundInfo;
